import gql from "graphql-tag";

export const createVerificationRuleMutation = gql`
  mutation createVerificationRule(
    $name: String!
    $filter: CreateVerificationRuleFilterInput!
    $frequency: VerificationRuleFrequency!
    $notification: CreateVerificationRuleNotificationInput!
  ) {
    createVerificationRule(
      name: $name
      filter: $filter
      frequency: $frequency
      notification: $notification
    ) {
      success
    }
  }
`;

export const updateVerificationRuleMutation = gql`
  mutation updateVerificationRule(
    $id: ID!
    $name: String!
    $filter: UpdateVerificationRuleFilterInput!
    $frequency: VerificationRuleFrequency!
    $notification: UpdateVerificationRuleNotificationInput!
  ) {
    updateVerificationRule(
      id: $id
      name: $name
      filter: $filter
      frequency: $frequency
      notification: $notification
    ) {
      success
    }
  }
`;

export const deleteVerificationRuleMutation = gql`
  mutation deleteVerificationRuleMutation($id: ID!) {
    deleteVerificationRule(id: $id) {
      success
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/verificationRuleMutations.js